(function(){
"use strict";
var BASE = "https://tabletopterrain.com/products/";

/* ---------- hill sets & volumes ----------
   v: [monoVariantId, monoPrice, ngcVariantId, ngcPrice]  (ngc omitted = single finish) */
var SETS = {
  AS:{name:"Atlean Steppes", handle:"atlean-steppes-map-hill-sets-hextech-6mm", full:[44451316695267,385,48867792453859,462]},
  PB:{name:"Piedmont Bluffs", handle:"piedmont-bluffs-map-hill-sets-hextech-6mm", full:[44451950395619,142]},
  TP:{name:"Tetran Plains", handle:"tetran-plains-map-hill-sets-hextech-6mm", full:[44451988340963,48,49011136135395,62]},
  ZB:{name:"Zephyr Badlands", handle:"zephyr-badlands-map-hill-sets-hextech-6mm", full:[44452011081955,99]},
  SW:{name:"Sundered Wastes", handle:"sundered-wastes-map-hill-sets-hextech-6mm", full:[48478176936163,640,44452035231971,828]},
  IR:{name:"Invader's Run", handle:"hextech-invaders-run-map-hill-sets-6mm", full:[46137718833379,285]},
  MJ:{name:"Mercenary Junction", handle:"hextech-mercenary-junction-map-hill-sets-6mm", full:[46137744130275,155]},
  TV:{name:"The Veldt", handle:"hextech-the-veldt-map-hill-sets-6mm", full:[46421447540963,328]},
  CHP:{name:"Heliport / Plaza", handle:"hextech-heliport-plaza-city-map-pack", full:[47253737799907,351]},
  CEB:{name:"HPG Engineering / Business District", handle:"hextech-hpg-engineering-business-district-city-map-pack", full:[47253700968675,322]},
  CPS:{name:"Central Park / Shopping District", handle:"hextech-central-park-shopping-district-city-map-pack", full:[47253637824739,439]},
  CBF:{name:"City / Lunar BFM", handle:"hextech-city-map-pack", full:[47253354610915,787]},
  FOB:{name:"Forward Operating Base", handle:"hextech-forward-operating-base-6mm", full:[45433377652963,105]},
  RCC:{name:"Riverside Communications Center", handle:"hextech-riverside-communications-center-6mm", full:[45433366511843,95]}
};

/* semi-modular sets sold as foundation + buildings — the foundation alone is the terrain fit */
var ALT = {
  FOB_FS:["Foundation only",45433377718499,85],
  RCC_FS:["Foundation only",45433366577379,75]
};

var V = {
  AS1:["AS","Vol 1 &mdash; Grasslands #2",44451316728035,31,48867792486627,37],
  AS2:["AS","Vol 2 &mdash; Grasslands #3",44451316760803,68,48867792519395,82],
  AS3:["AS","Vol 3 &mdash; Rolling Hills #1",44451316793571,85,48867792552163,102],
  AS4:["AS","Vol 4 &mdash; Rolling Hills #3",44451316826339,68,48867792584931,82],
  AS5:["AS","Vol 5 &mdash; Rolling Hills #4",44451316859107,72,48867792617699,86],
  AS6:["AS","Vol 6 &mdash; Lakes",44451316891875,54,48867792650467,65],
  AS7:["AS","Vol 7 &mdash; Streams",44451316924643,19,48867792683235,23],
  AS8:["AS","Vol 8 &mdash; Woodlands",44451316957411,30,48867792716003,36],

  PB1:["PB","Vol 1 &mdash; Foothills #1",44451950428387,85],
  PB2:["PB","Vol 2 &mdash; Foothills #2",44451950461155,72],

  TP1:["TP","Vol 1 &mdash; Open Terrain #2",44451988373731,30,49011136168163,38],
  TP2:["TP","Vol 2 &mdash; Open Terrain #3",44451988406499,23,49011136200931,29],

  ZB1:["ZB","Vol 1 &mdash; Desert #2",44452011114723,27],
  ZB2:["ZB","Vol 2 &mdash; Desert #3",44452011147491,83],

  SWA:["SW","Airbase",48478176968931,75,44452817928419,155],
  SW1:["SW","Vol 1 &mdash; Badlands #1",48478177001699,27,44452035264739,31],
  SW2:["SW","Vol 2 &mdash; Badlands #2",48478177034467,116,44452035297507,133],
  SW3:["SW","Vol 3 &mdash; Mines #1",48478177067235,83,44452770316515,95],
  SW4:["SW","Vol 4 &mdash; Mines #2",48478177100003,27,44452770349283,31],
  SW5:["SW","Vol 5 &mdash; Oasis",48478177132771,28,44452770382051,60],
  SW6:["SW","Vol 6 &mdash; Runway",48478177165539,23,44452770414819,27],
  SW7:["SW","Vol 7 &mdash; Sand Drift #1",48478177198307,74,44452770447587,85],
  SW8:["SW","Vol 8 &mdash; Sand Drift #2",48478177231075,98,44452770480355,113],
  SW9:["SW","Vol 9 &mdash; Washout #1",48478177263843,53,44452770513123,61],
  SW10:["SW","Vol 10 &mdash; Washout #2",48478177296611,56,44452770545891,65],

  IR1:["IR","Vol 1 &mdash; Barren Lands #1",46137718866147,54],
  IR2:["IR","Vol 2 &mdash; Barren Lands #2",46137718898915,67],
  IR3:["IR","Vol 3 &mdash; Hilltops #1",46137718931683,70],
  IR4:["IR","Vol 4 &mdash; Rolling Hills #2",46137718964451,94],

  MJ1:["MJ","Vol 1 &mdash; River Valley",46137744163043,74],
  MJ2:["MJ","Vol 2 &mdash; Scattered Woods",46137744195811,18],
  MJ3:["MJ","Vol 3 &mdash; Lake Area",46137744228579,27],
  MJ4:["MJ","Vol 4 &mdash; Woodland",46137744261347,36],

  TV1:["TV","Vol 1 &mdash; Mountain Lake",46421447573731,60],
  TV2:["TV","Vol 2 &mdash; Large Lakes #1",46421447606499,36],
  TV3:["TV","Vol 3 &mdash; Large Lakes #2",46421447639267,36],
  TV4:["TV","Vol 4 &mdash; BattleTech",46421447672035,22],
  TV5:["TV","Vol 5 &mdash; CityTech",46421523267811,8],
  TV6:["TV","Vol 6 &mdash; Box Canyon",46421523300579,178],
  TV7:["TV","Vol 7 &mdash; Wide River",46427134558435,26],

  /* City Map Pack — pieces are cut per mat pairing */
  CHP_O:["CHP","HPG Offices",47253737832675,63],
  CHP_H:["CHP","HPG Heliport",47255884726499,63],
  CHP_R:["CHP","Roundabout",47253737865443,120],
  CHP_P:["CHP","Plaza",47255825481955,143],
  CEB_B:["CEB","Business District",47253701001443,73],
  CEB_O:["CEB","Observatory Hill",47253701034211,129],
  CEB_F:["CEB","Family Quarters",47255824302307,54],
  CEB_E:["CEB","HPG Engineering",47255824335075,102],
  CPS_C:["CPS","Corporate Campus",47253637857507,124],
  CPS_P:["CPS","Central Park",47253637890275,95],
  CPS_S:["CPS","Shopping District",47255822467299,124],
  CPS_D:["CPS","Park District",47255822500067,145],
  CBF_B:["CBF","Business District",47253354643683,73],
  CBF_E:["CBF","HPG Engineering",47253354676451,102],
  CBF_O:["CBF","HPG Offices",47255816667363,63],
  CBF_H:["CBF","HPG Heliport",47255816700131,63],
  CBF_F:["CBF","Family Quarters",47255816732899,54],
  CBF_P:["CBF","Central Park",47255816765667,95],
  CBF_C:["CBF","Corporate Campus",47255816798435,124],
  CBF_R:["CBF","Roundabout",47255816831203,120],

  FOB_FS:["FOB","Full Set &mdash; foundation + buildings",45433377652963,105],
  RCC_FS:["RCC","Full Set &mdash; foundation + buildings",45433366511843,95]
};

/* ---------- map sheets ----------
   name, volume key (null = no hill set), origin note */
var S = {
  "grass1"   :["Grasslands #1",      null, "Beginner Box"],
  "grass2"   :["Grasslands #2",      "AS1","A Game of Armored Combat","Headwater Crossing"],
  "grass3"   :["Grasslands #3",      "AS2","A Game of Armored Combat","Sodden Hills"],
  "des1"     :["Desert #1",          null, "Beginner Box"],
  "des2"     :["Desert #2",          "ZB1","A Game of Armored Combat","Scorched Oasis"],
  "des3"     :["Desert #3",          "ZB2","A Game of Armored Combat","Arid Canyons"],
  "foot1"    :["Foothills #1",       "PB1","Map Pack: Grasslands"],
  "foot2"    :["Foothills #2",       "PB2","Map Pack: Grasslands"],
  "ot2"      :["Open Terrain #2",    "TP1","Map Pack: Grasslands"],
  "ot3"      :["Open Terrain #3",    "TP2","Map Pack: Grasslands"],
  "rh1"      :["Rolling Hills #1",   "AS3","Map Pack: Grasslands"],
  "rh2"      :["Rolling Hills #2",   "IR4","Clan Invasion box"],
  "rh3"      :["Rolling Hills #3",   "AS4","Map Pack: Grasslands"],
  "rh4"      :["Rolling Hills #4",   "AS5","Map Pack: Grasslands"],
  "lakes"    :["Lakes",              "AS6","Map Pack: Grasslands"],
  "streams"  :["Streams",            "AS7","Map Pack: Grasslands"],
  "wood"     :["Woodland",           "AS8","Map Pack: Grasslands"],
  "fwdbase"  :["Forward Base",       "FOB_FS","Map Pack: Grasslands"],
  "rivercc"  :["River CommCenter",   "RCC_FS","Map Pack: Grasslands"],
  "barren1"  :["Barren Lands #1",    "IR1","Clan Invasion box"],
  "barren2"  :["Barren Lands #2",    "IR2","Clan Invasion box"],
  "hilltops1":["Hilltops #1",        "IR3","Clan Invasion box"],
  "rivval"   :["River Valley",       "MJ1","Mercenaries box"],
  "scatwood" :["Scattered Woods",    "MJ2","Mercenaries box"],
  "lakearea" :["Lake Area",          "MJ3","Mercenaries box"],
  "woodmerc" :["Woodland",           "MJ4","Mercenaries box"],
  "aero1"    :["AeroBase #1",        "SWA","Map Pack: Deserts"],
  "aero2"    :["AeroBase #2",        "SWA","Map Pack: Deserts"],
  "bad1"     :["Badlands #1",        "SW1","Map Pack: Deserts"],
  "bad2"     :["Badlands #2",        "SW2","Map Pack: Deserts"],
  "mines1"   :["Mines #1",           "SW3","Map Pack: Deserts"],
  "mines2"   :["Mines #2",           "SW4","Map Pack: Deserts"],
  "oasis"    :["Oasis",              "SW5","Map Pack: Deserts"],
  "runway"   :["Desert Runway",      "SW6","Map Pack: Deserts"],
  "sand1"    :["Sand Drift #1",      "SW7","Map Pack: Deserts"],
  "sand2"    :["Sand Drift #2",      "SW8","Map Pack: Deserts"],
  "wash1"    :["Washout #1",         "SW9","Map Pack: Deserts"],
  "wash2"    :["Washout #2",         "SW10","Map Pack: Deserts"],
  "mtlake"   :["Mountain Lake",      "TV1","Map Pack: Savannah"],
  "ll1"      :["Large Lakes #1",     "TV2","Map Pack: Savannah"],
  "ll2"      :["Large Lakes #2",     "TV3","Map Pack: Savannah"],
  "btech"    :["BattleTech",         "TV4","Map Pack: Savannah"],
  "ctech"    :["CityTech",           "TV5","Map Pack: Savannah"],
  "boxcan"   :["Box Canyon",         "TV6","Map Pack: Savannah"],
  "widriv"   :["Wide River",         "TV7","Map Pack: Savannah"],
  "sink1"    :["Sinkhole #1",        null, "Map Pack: Savannah"],
  "sink2"    :["Sinkhole #2",        null, "Map Pack: Savannah"],
  "cityruin" :["City Ruins",         null, "Map Pack: Savannah"],
  "rdelta1"  :["River Delta / Drainage Basin #1", null,"Map Pack: Savannah"],
  "rdelta2"  :["River Delta / Drainage Basin #2", null,"Map Pack: Savannah"],
  /* City Map Pack — hill/building sets are cut per BattleMat pairing */
  "c_cpark"  :["City: Central Park",       "CPS_P","Map Pack: City"],
  "c_bdist"  :["City: Business District",  "CEB_B","Map Pack: City"],
  "c_ccamp"  :["City: Corporate Campus",   "CPS_C","Map Pack: City"],
  "c_round"  :["City: Roundabout",         "CHP_R","Map Pack: City"],
  "c_fquart" :["City: Family Quarters",    "CEB_F","Map Pack: City"],
  "c_obs"    :["City: Observatory Hill",   "CEB_O","Map Pack: City"],
  "c_hpge"   :["City: HPG Engineering",    "CEB_E","Map Pack: City"],
  "c_pdist"  :["City: Park District",      "CPS_D","Map Pack: City"],
  "c_heli"   :["City: HPG Heliport",       "CHP_H","Map Pack: City"],
  "c_shop"   :["City: Shopping District",  "CPS_S","Map Pack: City"],
  "c_hpgo"   :["City: HPG Offices",        "CHP_O","Map Pack: City"],
  "c_plaza"  :["City: Plaza",              "CHP_P","Map Pack: City"]
};

/* ---------- boxed sets & map packs ---------- */
var PRODUCTS = [
  {id:"agoac", group:"Boxed sets", name:"BattleTech: A Game of Armored Combat", code:"CAT35010",
   meta:"2 double-sided 18″ × 22″ paper mapsheets",
   sides:[{label:"Sheet 1", f:["grass2","des2"]},{label:"Sheet 2", f:["grass3","des3"]}],
   note:"Fully covered: Atlean Steppes Vols 1&ndash;2 for the grasslands faces, Zephyr Badlands Vols 1&ndash;2 for the deserts. These same four maps return in the 2026 Core Box under new names &mdash; same layouts, same hills."},

  {id:"corebox2026", group:"Boxed sets", name:"BattleTech: Core Box (2026)", code:"CAT37002",
   meta:"2 double-sided mapsheets - 4 faces", useAlias:true,
   sides:[{label:"The four map faces", f:["grass2","grass3","des2","des3"]}],
   note:"The 2026 Core Box reprints the four A Game of Armored Combat maps with revised art and new names. The hex layouts and elevations are unchanged, so the existing hill sets fit exactly &mdash; Atlean Steppes Vols 1&ndash;2 for the two grassland maps, Zephyr Badlands Vols 1&ndash;2 for the two desert maps."},

  {id:"beginner", group:"Boxed sets", name:"BattleTech: Beginner Box", code:"CAT35000",
   meta:"1 double-sided 18″ × 22″ paper mapsheet",
   sides:[{label:"Sheet 1", f:["grass1","des1"]}],
   note:"No hill sets exist for Grasslands #1 or Desert #1 yet. If you're stepping up from the Beginner Box, A Game of Armored Combat's four faces are all covered."},

  {id:"claninv", group:"Boxed sets", name:"BattleTech: Clan Invasion", code:"CAT35030",
   meta:"2 double-sided 18″ × 22″ paper mapsheets",
   sides:[{label:"Sheet 1", f:["hilltops1","barren1"]},{label:"Sheet 2", f:["rh2","barren2"]}],
   note:"All four faces are covered by Invader's Run &mdash; the Full Set Bundle is the whole box in one order."},

  {id:"mercs", group:"Boxed sets", name:"BattleTech: Mercenaries", code:"CAT35040",
   meta:"2 double-sided 18″ × 22″ paper mapsheets",
   sides:[{label:"Sheet 1", f:["scatwood","rivval"]},{label:"Sheet 2", f:["woodmerc","lakearea"]}],
   note:"All four faces are covered by Mercenary Junction. Note this box's Woodland is its own map &mdash; it is not the Map Pack: Grasslands Woodland, which uses Atlean Steppes Vol 8."},

  {id:"mp-grass", group:"Map packs", name:"Map Pack: Grasslands", code:"CAT35154",
   meta:"6 double-sided 18″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["foot1","rh1"]},
     {label:"Sheet 2", f:["foot2","lakes"]},
     {label:"Sheet 3", f:["ot2","wood"]},
     {label:"Sheet 4", f:["ot3","fwdbase"]},
     {label:"Sheet 5", f:["rh3","streams"]},
     {label:"Sheet 6", f:["rh4","rivercc"]}],
   note:"All twelve faces are covered, across five products. The two facility maps use the stand-alone base sets, which ship as a foundation plus hexed buildings &mdash; the foundation alone is what matches the printed map, so it's listed separately below."},

  {id:"mp-des", group:"Map packs", name:"Map Pack: Deserts", code:"CAT35155",
   meta:"6 double-sided 18″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["aero1","bad1"]},
     {label:"Sheet 2", f:["bad2","aero2"]},
     {label:"Sheet 3", f:["mines1","runway"]},
     {label:"Sheet 4", f:["oasis","sand2"]},
     {label:"Sheet 5", f:["wash2","mines2"]},
     {label:"Sheet 6", f:["sand1","wash1"]}],
   note:"Sundered Wastes covers all twelve faces. One Airbase set serves both AeroBase #1 and AeroBase #2."},

  {id:"mp-sav", group:"Map packs", name:"Map Pack: Savannah", code:"CAT35156",
   meta:"6 double-sided 17″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["ll1","btech"]},
     {label:"Sheet 2", f:["ll2","boxcan"]},
     {label:"Sheet 3", f:["sink1","cityruin"]},
     {label:"Sheet 4", f:["sink2","ctech"]},
     {label:"Sheet 5", f:["rdelta1","mtlake"]},
     {label:"Sheet 6", f:["rdelta2","widriv"]}],
   note:"The Veldt covers seven of the twelve faces. The Sinkholes, City Ruins and River Delta faces have no hill set yet."},

  {id:"mp-city", group:"Map packs", name:"Map Pack: City", code:"CAT35157",
   meta:"6 double-sided 17″ × 22″ paper maps — 12 faces",
   sides:[
     {label:"Sheet 1", f:["c_cpark","c_bdist"]},
     {label:"Sheet 2", f:["c_ccamp","c_round"]},
     {label:"Sheet 3", f:["c_fquart","c_obs"]},
     {label:"Sheet 4", f:["c_hpge","c_pdist"]},
     {label:"Sheet 5", f:["c_heli","c_shop"]},
     {label:"Sheet 6", f:["c_hpgo","c_plaza"]}],
   note:"City pieces are cut per BattleMat pairing rather than as one numbered range, so the twelve faces span three products. If you own the paper pack, the parts below still line up face-for-face. Buying by mat instead? Use the BattleMats tab."},

  {id:"mp-alien", group:"Map packs", name:"Map Pack: Alien Worlds", code:"CAT35158",
   meta:"2 double-sided 34″ × 22″ paper maps — 4 faces",
   sides:[{label:"Faces", f:[]}],
   raw:["Fungal Crevasse","Caustic Valley","Lunar Base","Crystalline Canyon"],
   note:"No hill sets for the Alien Worlds faces. If you own the neoprene versions, note that their reverse sides are Map Pack: Deserts maps &mdash; those are covered by Sundered Wastes. Check the BattleMats tab."},

  {id:"mp-tuk", group:"Map packs", name:"Map Pack: Battle of Tukayyid", code:"CAT35153",
   meta:"4 double-sided 34″ × 22″ paper maps — 8 faces",
   sides:[{label:"Faces", f:[]}],
   raw:["Racice River Delta","Deployment Zone","Holth Forest","Lake Losiije","Robyn's Crossing","Devil's Bath","Pozoristu Mountains","Kozice Valley"],
   note:"No hill sets for the Tukayyid maps."},

  {id:"mp-fire", group:"Map packs", name:"Map Pack: Volcanic &amp; Glacier", code:"CAT35160/61",
   meta:"12 faces each",
   sides:[{label:"Faces", f:[]}],
   raw:["All Volcanic faces","All Glacier faces"],
   note:"No hill sets for the Fire and Ice ranges yet."}
];

/* ---------- neoprene BattleMats ---------- */
var MATS = [
  {id:"rgk", group:"Starter", name:"BattleTech: Retail Grinder Kit mat", code:"CAT35RGK",
   meta:"Reproduces the A Game of Armored Combat maps",
   sides:[{label:"Side A", f:["grass3"]},{label:"Side B", f:["des2"]}]},

  {id:"800a", group:"Grassland Collection", name:"Grasslands A / Desert", code:"CAT35800A", meta:"34″ × 22″ — two mapsheets per side",
   sides:[{label:"Grasslands side", f:["foot2","rh4"]},{label:"Desert side", f:[]}],
   raw:["New desert artwork — no paper original"],
   note:"Only the grasslands side reproduces printed map sheets. The reverse is new biome art with no corresponding hill set."},
  {id:"800b", group:"Grassland Collection", name:"Grasslands B / Lunar", code:"CAT35800B", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["fwdbase","ot2"]},{label:"Lunar side", f:[]}],
   raw:["New lunar artwork — no paper original"]},
  {id:"800c", group:"Grassland Collection", name:"Grasslands C / Alpine", code:"CAT35800C", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["rh3","foot1"]},{label:"Alpine side", f:[]}],
   raw:["New alpine artwork — no paper original"]},
  {id:"800d", group:"Grassland Collection", name:"Grasslands D / Savanna", code:"CAT35800D", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["ot3","streams"]},{label:"Savanna side", f:[]}],
   raw:["New savanna artwork — no paper original"]},
  {id:"800e", group:"Grassland Collection", name:"Grasslands E / Tundra", code:"CAT35800E", meta:"34″ × 22″",
   sides:[{label:"Grasslands side", f:["lakes","rivercc"]},{label:"Tundra side", f:[]}],
   raw:["New tundra artwork — no paper original"]},

  {id:"800p", group:"Alien Worlds Collection", name:"Lunar Base / Sand Drift", code:"CAT35800P", meta:"34″ × 22″",
   sides:[{label:"Lunar Base side", f:[]},{label:"Sand Drift side", f:["sand1","sand2"]}],
   raw:["Lunar Base — no hill set"]},
  {id:"800q", group:"Alien Worlds Collection", name:"Fungal Crevasse / Washout", code:"CAT35800Q", meta:"34″ × 22″",
   sides:[{label:"Fungal Crevasse side", f:[]},{label:"Washout side", f:["wash1","wash2"]}],
   raw:["Fungal Crevasse — no hill set"]},
  {id:"800r", group:"Alien Worlds Collection", name:"Caustic Valley / Mine", code:"CAT35800R", meta:"34″ × 22″",
   sides:[{label:"Caustic Valley side", f:[]},{label:"Mine side", f:["mines1","mines2"]}],
   raw:["Caustic Valley — no hill set"]},
  {id:"800s", group:"Alien Worlds Collection", name:"Crystalline Canyon / Badlands", code:"CAT35800S", meta:"34″ × 22″",
   sides:[{label:"Crystalline Canyon side", f:[]},{label:"Badlands side", f:["bad1","bad2"]}],
   raw:["Crystalline Canyon — no hill set"]},

  {id:"800v", group:"Alpha Strike hexless", name:"Aerobase #1", code:"CAT35800V", meta:"34″ × 22″ — hexless",
   sides:[{label:"Desert side", f:["aero1","aero2"]},{label:"Grasslands side", f:["wood","rh1"]}],
   note:"Its desert side is AeroBase #1 and #2, and the single Airbase pack covers both &mdash; you only need one. Hexless mats take the same hills either way: the pieces are cut to the printed contours, not to the hex grid."},
  {id:"800w", group:"Alpha Strike hexless", name:"Aerobase #2", code:"CAT35800W", meta:"34″ × 22″ — hexless",
   sides:[{label:"Desert side", f:["runway","oasis"]},{label:"Grasslands side", f:["hilltops1","rh2"]}],
   note:"The grasslands side of this mat reproduces the Hilltops #1 and Rolling Hills #2 sheets, which ship in the Clan Invasion box &mdash; so those two come from Invader's Run rather than Atlean Steppes."},

  {id:"800mm", group:"Battalion Forces Mats (72″ × 48″)", name:"BFM Grasslands / Deserts", code:"CAT35800MM",
   meta:"72″ × 48″ — eight mapsheets per side",
   sides:[
     {label:"Deserts side", f:["bad2","wash1","aero1","aero2","wash2","mines2","runway","oasis"]},
     {label:"Grasslands side", f:["rh4","rh1","streams","lakes","rh3","ot2","rivercc","ot3"]}],
   note:"The big one. Eight map faces per side, so this needs the most volumes of any mat &mdash; the bundle maths below is worth reading."},

  {id:"801a", group:"Savannah Collection", name:"Large Lakes / Box Canyon", code:"CAT35801A", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["ll1","ll2"]},{label:"Side B", f:["boxcan","btech"]}]},
  {id:"801b", group:"Savannah Collection", name:"River Delta / City Ruins", code:"CAT35801B", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["rdelta1","rdelta2"]},{label:"Side B", f:["cityruin","ctech"]}]},
  {id:"801c", group:"Savannah Collection", name:"Sinkholes / Mountain Lake", code:"CAT35801C", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["sink1","sink2"]},{label:"Side B", f:["mtlake","widriv"]}]},

  {id:"801x", group:"City Collection", name:"City &mdash; HPG Heliport / Plaza", code:"CAT35801X", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["c_heli","c_hpgo"]},{label:"Side B", f:["c_plaza","c_round"]}],
   note:"Every piece for this mat lives in one product &mdash; the Heliport / Plaza set. Buy the Full Set for the whole mat."},
  {id:"801y", group:"City Collection", name:"City &mdash; HPG Engineering / Business District", code:"CAT35801Y", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["c_hpge","c_obs"]},{label:"Side B", f:["c_bdist","c_fquart"]}],
   note:"Every piece for this mat lives in one product &mdash; the HPG Engineering / Business District set."},
  {id:"801z", group:"City Collection", name:"City &mdash; Central Park / Shopping District", code:"CAT35801Z", meta:"34″ × 22″",
   sides:[{label:"Side A", f:["c_cpark","c_ccamp"]},{label:"Side B", f:["c_shop","c_pdist"]}],
   note:"Every piece for this mat lives in one product &mdash; the Central Park / Shopping District set."},

  {id:"801mm", group:"Battalion Forces Mats (72″ × 48″)", name:"BFM City / Lunar", code:"CAT35801MM",
   meta:"72″ × 48″ — eight city maps on the city side",
   sides:[{label:"City side", f:[]},{label:"Lunar side", f:[]}],
   custom:"CBF",
   note:"The BFM city pieces are their own product, sized and arranged for the 72″ × 48″ mat &mdash; don't substitute the 34″ × 22″ city sets. Two extra centrepieces, the Central Facility Raised Structure and the Interstellar Communications Facility, are exclusive to this mat. The lunar side has no hill set."},

  {id:"802mm", group:"Battalion Forces Mats (72″ × 48″)", name:"BFM Volcanic / Glacier", code:"CAT35802MM",
   meta:"72″ × 48″", sides:[{label:"Both sides", f:[]}],
   raw:["Volcanic and Glacier faces — no hill sets yet"]},

  {id:"tuk", group:"No hill sets yet", name:"Battle of Tukayyid mats", code:"CAT35800F–I", meta:"Racice River Delta, Holth Forest, Robyn's Crossing, Pozoristu Mountains and their reverses",
   sides:[{label:"All faces", f:[]}], raw:["No hill sets"]},
  {id:"misc", group:"No hill sets yet", name:"Strana Mechty, Aerospace, FieldTech, Legendary Battles, Fire and Ice", code:"CAT35800J–L, 35801D–Q", meta:"Hexless FieldTech mats, Thunder Rift / Misery, Twycross, the Fire and Ice range",
   sides:[{label:"All faces", f:[]}], raw:["No hill sets"]}
];

/* ---------- state ---------- */
var color = "ngc";
var tab = "products";
var sel = {products:"mp-grass", mats:"800mm", sheets:"rh1"};
var q = "";

var listEl = document.getElementById("hf-list");
var mqNarrow = window.matchMedia("(max-width: 880px)");
var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
var resEl = document.getElementById("hf-result");
var root = document.querySelector(".hf");

/* ---------- live pricing ----------
   When this block runs inside the Shopify Custom Liquid section, the theme
   has already emitted window.TT_LIVE with the real price and stock of every
   variant, rendered server-side in the buyer's own market and currency.
   Outside Shopify (preview, static file) it falls back to the USD figures
   baked into the tables above. */
var LIVE = (window.TT_LIVE && window.TT_LIVE.variants) || null;
var CURRENCY = (window.TT_LIVE && window.TT_LIVE.currency) || "USD";
var fmt;
try{ fmt = new Intl.NumberFormat(undefined, {style:"currency", currency:CURRENCY}); }
catch(e){ fmt = null; }

function money(n){
  if(fmt) return fmt.format(n);
  return "$" + n.toFixed(2);
}
/* price in major units for a variant, falling back to the baked-in figure */
function px(variantId, fallback){
  if(LIVE){
    var row = LIVE[variantId];
    if(row) return row[0] / 100;
  }
  return fallback;
}
function inStock(variantId){
  if(!LIVE) return true;
  var row = LIVE[variantId];
  return row ? !!row[1] : true;
}

function vol(key){
  var v = V[key]; if(!v) return null;
  var hasNgc = v.length > 4;
  var useNgc = (color === "ngc") && hasNgc;
  var id = useNgc ? v[4] : v[2];
  return {
    setKey:v[0], set:SETS[v[0]], label:v[1],
    variant: id,
    price: px(id, useNgc ? v[5] : v[3]),
    stock: inStock(id),
    onlyFinish: !hasNgc
  };
}
function fullOf(setKey){
  var f = SETS[setKey].full;
  var hasNgc = f.length > 2;
  var useNgc = (color === "ngc") && hasNgc;
  var id = useNgc ? f[2] : f[0];
  return { variant: id, price: px(id, useNgc ? f[3] : f[1]), stock: inStock(id) };
}
/* Inside Shopify, build links off Shopify.routes.root so locale and market
   prefixes (/en-gb/, /fr/) survive. Outside it, fall back to absolute URLs. */
var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || null;
var ON_SHOPIFY = !!ROOT || !!LIVE;
function url(handle, variant){
  return (ROOT ? ROOT + "products/" + handle : BASE + handle) + "?variant=" + variant;
}
function route(p){ return (ROOT || "/") + p; }

/* The 2026 Core Box reprints four A Game of Armored Combat maps under new
   names. Show whichever name matches the box in front of the customer, and
   name the other one underneath so both searches land. */
function sheetTitle(s, useAlias){ return (useAlias && s[3]) ? s[3] : s[0]; }
function sheetSub(s, hideOrigin, useAlias){
  var bits = [];
  if(useAlias && s[3]) bits.push("Same map as " + s[0]);
  else {
    if(!hideOrigin) bits.push(s[2]);
    if(s[3]) bits.push("2026 Core Box: " + s[3]);
  }
  return bits.length ? '<small>' + bits.join(" &middot; ") + '</small>' : "";
}

/* Full Set call to action: add straight to cart, with the product page beside it */
function ctaBlock(handle, variant, price){
  var link = url(handle, variant);
  return '<span class="bundle__act">'
       + '<button type="button" class="cta" data-add="'+variant+'" data-href="'+link+'">Add Full Set '+money(price)+'</button>'
       + '<a class="view" href="'+link+'" target="_blank" rel="noopener noreferrer">View product</a>'
       + '</span>';
}

/* ---------- ajax cart ---------- */
var cartBar = document.getElementById("hf-cartbar");
var cartCount = document.getElementById("hf-cartcount");
var cartLink = document.getElementById("hf-cartlink");

/* variantId -> quantity already in the buyer's cart, read from /cart.js so
   items added on a previous visit or another tab show up here too */
var inCart = {};

function refreshCart(){
  if(!ON_SHOPIFY) return;
  fetch(route("cart.js"), {headers:{"Accept":"application/json"}, credentials:"same-origin"})
    .then(function(r){ return r.json(); })
    .then(function(cart){
      inCart = {};
      (cart.items || []).forEach(function(it){
        inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity;
      });

      /* nudge whatever the theme uses for its cart bubble */
      var sels = "[data-cart-count],.cart-count,.cart-count-bubble span,.header__cart-count,#CartCount,#cart-icon-bubble .cart-count-bubble span";
      document.querySelectorAll(sels).forEach(function(el){ el.textContent = cart.item_count; });
      ["cart:refresh","cart:updated","cart-updated","ajaxProduct:added"].forEach(function(n){
        document.dispatchEvent(new CustomEvent(n, {bubbles:true, detail:{cart:cart}}));
      });

      cartLink.setAttribute("href", route("cart"));
      cartCount.textContent = cart.item_count === 1
        ? "1 item in your cart"
        : cart.item_count + " items in your cart";
      cartBar.hidden = cart.item_count === 0;

      renderResult();
    })
    .catch(function(){});
}

function cartAdd(ids, btn, doneLabel){
  var reset = btn.innerHTML;
  btn.disabled = true;
  btn.classList.remove("buy--err");
  btn.innerHTML = "Adding&hellip;";
  fetch(route("cart/add.js"), {
    method:"POST",
    headers:{"Content-Type":"application/json","Accept":"application/json"},
    credentials:"same-origin",
    body: JSON.stringify({items: ids.map(function(id){ return {id: Number(id), quantity: 1}; })})
  })
  .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
  .then(function(res){
    if(!res.ok) throw new Error(res.body.description || res.body.message || "Could not add");
    btn.disabled = false;
    btn.classList.add("buy--added");
    btn.innerHTML = doneLabel || "Added &#10003;";
    refreshCart();
  })
  .catch(function(err){
    btn.disabled = false;
    btn.classList.add("buy--err");
    btn.innerHTML = "Try again";
    setTimeout(function(){ btn.classList.remove("buy--err"); btn.innerHTML = reset; }, 2600);
    if(window.console) console.warn("[hill-finder] add to cart failed:", err.message);
  });
}

/* ---------- list ---------- */
function items(){
  /* aliases go into the search haystack so both the old and the 2026 names hit */
  function faceWords(sides){
    return (sides||[]).map(function(s){
      return s.f.map(function(k){ return S[k][0] + " " + (S[k][3] || ""); }).join(" ");
    }).join(" ");
  }
  if(tab === "products") return PRODUCTS.map(function(p){return {id:p.id,name:p.name,code:p.code,group:p.group,hay:p.name+" "+p.code+" "+faceWords(p.sides)};});
  if(tab === "mats") return MATS.map(function(m){return {id:m.id,name:m.name,code:m.code,group:m.group,hay:m.name+" "+m.code+" "+faceWords(m.sides)};});
  return Object.keys(S).map(function(k){
    var s = S[k];
    return {
      id:k,
      name:s[0] + (s[3] ? ' <em class="alias">' + s[3] + '</em>' : ""),
      sortName:s[0],
      code:s[1] ? "●" : "—",
      group:s[2],
      hay:s[0]+" "+s[2]+" "+(s[3] || "")
    };
  }).sort(function(a,b){ return a.group.localeCompare(b.group) || a.sortName.localeCompare(b.sortName); });
}
/* every tab shows its own count, so all three read as populated choices */
function setCounts(){
  var c = {products:PRODUCTS.length, mats:MATS.length, sheets:Object.keys(S).length};
  Object.keys(c).forEach(function(k){
    var el = document.querySelector('[data-count="'+k+'"]');
    if(el) el.textContent = c[k];
  });
}
function strip(h){ return h.replace(/&mdash;/g,"-").replace(/&amp;/g,"&").replace(/&ndash;/g,"-"); }

function renderList(){
  var all = items();
  var ql = q.trim().toLowerCase();
  var shown = ql ? all.filter(function(i){ return strip(i.hay).toLowerCase().indexOf(ql) !== -1; }) : all;
  if(!shown.length){ listEl.innerHTML = '<p class="hf__empty">Nothing matches &ldquo;'+q.replace(/</g,"&lt;")+'&rdquo;. Try a sheet name like &ldquo;Rolling Hills&rdquo;.</p>'; return; }
  var html = "", g = null, open = false;
  shown.forEach(function(i){
    if(i.group !== g){
      if(open) html += "</div>";
      g = i.group;
      html += '<div class="hf__group">'+g+'</div><div class="hf__list">';
      open = true;
    }
    html += '<button type="button" class="opt" data-id="'+i.id+'" aria-current="'+(sel[tab]===i.id)+'">'
          + '<span>'+i.name+'</span><span class="code">'+i.code+'</span></button>';
  });
  if(open) html += "</div>";
  listEl.innerHTML = html;
}

/* ---------- result ---------- */
function faceRow(key, n, hideOrigin, dupOf, useAlias){
  var s = S[key], v = s[1] ? vol(s[1]) : null;
  var cls = v ? "face face--yes" : "face face--none";
  var right;
  if(!v){
    right = '<span class="dash">&mdash;</span>';
  } else if(dupOf){
    /* the same volume already covers an earlier face in this view - one copy
       does both, so don't offer a second Add button */
    right = '<span class="dupnote">One copy covers both<small>already listed at face '+dupOf+'</small></span>';
  } else {
    var link = url(v.set.handle, v.variant);
    var qty = inCart[v.variant] || 0;
    right = (v.stock
      ? '<button type="button" class="buy'+(qty ? ' buy--incart' : '')+'" data-add="'+v.variant+'"'
        + ' data-href="'+link+'" title="'+(qty ? 'Add another' : 'Add to cart')+'">'
        + (qty ? 'In cart <span class="price">&times;'+qty+'</span>'
               : 'Add to cart <span class="price">'+money(v.price)+'</span>')
        + '</button>'
      : '<span class="buy buy--out">Sold out</span>')
      + '<a class="view" href="'+link+'" target="_blank" rel="noopener noreferrer">View product</a>';
  }
  var alt = (v && ALT[s[1]]) ? ALT[s[1]] : null;
  var mid = v
    ? '<span class="setname">'+v.set.name+'</span><b>'+v.label+'</b>'
      + (alt ? '<a class="alt" href="'+url(v.set.handle, alt[1])+'" target="_blank" rel="noopener noreferrer">'+alt[0]+' &middot; '+money(px(alt[1], alt[2]))+'</a>' : '')
    : 'No hill set yet';
  return '<div class="'+cls+'">'
       + '<span class="face__no">'+n+'</span>'
       + '<span class="face__sheet">'+sheetTitle(s, useAlias)+sheetSub(s, hideOrigin, useAlias)+'</span>'
       + '<span class="face__hill">'+mid+'</span>'
       + '<span class="face__buy">'+right+'</span></div>';
}

function basket(keys, customSetKey){
  var counts = {}, order = [];
  keys.forEach(function(k){
    var vk = S[k][1]; if(!vk) return;
    if(!counts[vk]){ counts[vk] = 0; order.push(vk); }
    counts[vk]++;
  });
  if(customSetKey){
    Object.keys(V).forEach(function(vk){
      if(V[vk][0] === customSetKey && order.indexOf(vk) === -1){ order.push(vk); counts[vk] = 1; }
    });
  }
  if(!order.length) return "";

  var total = 0, rows = "", bySet = {}, ids = [];
  order.forEach(function(vk){
    var v = vol(vk);
    total += v.price;
    if(v.stock) ids.push(v.variant);
    bySet[v.setKey] = (bySet[v.setKey] || 0) + 1;
    rows += '<div class="brow"><span><a href="'+url(v.set.handle, v.variant)+'" target="_blank" rel="noopener">'
          + v.set.name+' &middot; '+v.label+'</a>'
          + (counts[vk] > 1 ? ' <span class="qty">covers '+counts[vk]+' faces</span>' : '')
          + (inCart[v.variant] ? ' <span class="tag">in cart &times;'+inCart[v.variant]+'</span>' : '')
          + '</span><span class="amt">'+money(v.price)+'</span></div>';
  });

  /* bundle advice: any set where you need 3+ volumes and the Full Set costs less than the pieces */
  var advice = "";
  Object.keys(bySet).forEach(function(sk){
    var needed = 0;
    order.forEach(function(vk){ if(V[vk][0] === sk) needed += vol(vk).price; });
    var f = fullOf(sk);
    var setTotalVols = Object.keys(V).filter(function(vk){ return V[vk][0] === sk; }).length;
    if(bySet[sk] >= 3 && f.price < needed){
      advice += '<div class="bundle"><p><strong>'+SETS[sk].name+' Full Set Bundle</strong> is '+money(needed - f.price)
             + ' cheaper than buying these '+bySet[sk]+' volumes separately &mdash; and it includes all '+setTotalVols
             + ' volumes in the range.</p>'+ctaBlock(SETS[sk].handle, f.variant, f.price)+'</div>';
    } else if(bySet[sk] >= 3){
      advice += '<div class="bundle"><p><strong>'+SETS[sk].name+' Full Set Bundle</strong> adds the remaining volumes in the range for '
             + money(f.price - needed)+' more than these '+bySet[sk]+' on their own.</p>'
             + ctaBlock(SETS[sk].handle, f.variant, f.price)+'</div>';
    }
  });

  return '<section class="basket"><div class="basket__hd"><h3>What you need</h3>'
       + '<span class="tot">'+order.length+' '+(order.length===1?"set":"sets")+' &middot; '+money(total)+'</span>'
       + (function(){
            if(ids.length < 2) return "";
            var missing = ids.filter(function(id){ return !inCart[id]; });
            if(!missing.length) return '<span class="addall addall--done">All '+ids.length+' in cart &#10003;</span>';
            return '<button type="button" class="addall" data-addall="'+missing.join(",")+'">Add '
                 + (missing.length === ids.length ? 'all ' : 'remaining ')+missing.length+' to cart</button>';
          })()
       + '</div>'
       + '<div class="basket__rows">'+rows+'</div>'+advice+'</section>';
}

function renderResult(){
  var src = tab === "mats" ? MATS : tab === "products" ? PRODUCTS : null;
  var html = "";

  if(src){
    var item = null;
    for(var i=0;i<src.length;i++){ if(src[i].id === sel[tab]) item = src[i]; }
    if(!item){ resEl.innerHTML = ""; return; }

    var keys = [];
    (item.sides || []).forEach(function(s){ keys = keys.concat(s.f); });
    var covered = keys.filter(function(k){ return !!S[k][1]; }).length;
    var totalFaces = keys.length + (item.raw ? item.raw.length : 0);

    html += '<button type="button" class="res__back" data-back><b>&larr;</b> All '
          + (tab === "mats" ? "battlemats" : tab === "products" ? "sets &amp; packs" : "map sheets")
          + '</button>';
    html += '<p class="res__kicker">'+(tab === "mats" ? "Neoprene BattleMat" : item.group)+'</p>';
    html += '<h2 class="res__title">'+item.name+'</h2>';
    html += '<p class="res__meta">'+item.code+' &nbsp;&middot;&nbsp; '+item.meta+'</p>';

    if(totalFaces){
      var pct = Math.round((covered/totalFaces)*100);
      html += '<div class="cov"><div class="cov__bar"><div class="cov__fill" style="width:'+pct+'%"></div></div>'
            + '<span class="cov__txt">'+covered+' of '+totalFaces+' map faces have a hill set</span></div>';
    }
    if(item.note) html += '<p class="res__note">'+item.note+'</p>';

    html += '<div class="faces">';
    var n = 0, seen = {};
    (item.sides || []).forEach(function(s){
      if(!s.f.length && !item.raw) return;
      html += '<div class="side">'+s.label+'</div>';
      s.f.forEach(function(k){
        n++;
        var vk = S[k][1], dupOf = null;
        if(vk){
          if(seen[vk]) dupOf = seen[vk];
          else seen[vk] = n;
        }
        html += faceRow(k, n, strip(item.name) === S[k][2], dupOf, item.useAlias);
      });
    });
    if(item.raw){
      item.raw.forEach(function(t){
        n++;
        html += '<div class="face face--none"><span class="face__no">'+n+'</span>'
              + '<span class="face__sheet">'+t+'</span>'
              + '<span class="face__hill">No hill set yet</span>'
              + '<span class="face__buy"><span class="dash">&mdash;</span></span></div>';
      });
    }
    html += '</div>';
    html += basket(keys, item.custom);
  } else {
    var k = sel.sheets, s = S[k];
    var v = s[1] ? vol(s[1]) : null;
    html += '<button type="button" class="res__back" data-back><b>&larr;</b> All '
          + (tab === "mats" ? "battlemats" : tab === "products" ? "sets &amp; packs" : "map sheets")
          + '</button>';
    html += '<p class="res__kicker">Map sheet</p>';
    html += '<h2 class="res__title">'+s[0]+'</h2>';
    html += '<p class="res__meta">Ships in: '+s[2]
          + (s[3] ? ' &nbsp;&middot;&nbsp; 2026 Core Box name: '+s[3] : '')+'</p>';
    if(v){
      html += '<p class="res__note">One volume covers this sheet: <strong>'+v.set.name+' &mdash; '+v.label+'</strong>.'
            + (v.onlyFinish ? ' This set ships in monocolor grey only.' : '')+'</p>';
      html += '<div class="faces"><div class="side">The hill set for this sheet</div>'+faceRow(k,1)+'</div>';
      var f = fullOf(v.setKey);
      var cnt = Object.keys(V).filter(function(vk){ return V[vk][0] === v.setKey; }).length;
      var a = ALT[s[1]];
      html += '<section class="basket"><div class="basket__hd"><h3>What you need</h3><span class="tot">1 set &middot; '+money(v.price)+'</span></div>'
            + '<div class="basket__rows"><div class="brow"><span><a href="'+url(v.set.handle, v.variant)+'" target="_blank" rel="noopener">'
            + v.set.name+' &middot; '+v.label+'</a></span><span class="amt">'+money(v.price)+'</span></div>'
            + (a ? '<div class="brow"><span><a href="'+url(v.set.handle, a[1])+'" target="_blank" rel="noopener noreferrer">'
                 + v.set.name+' &middot; '+a[0]+'</a> <span class="qty">matches the map without the buildings</span></span>'
                 + '<span class="amt">'+money(px(a[1], a[2]))+'</span></div>' : '')
            + '</div>'
            + (cnt > 1
               ? '<div class="bundle"><p>Playing more of the range? The <strong>'+v.set.name+' Full Set Bundle</strong> covers all '+cnt+' volumes.</p>'
                 + ctaBlock(v.set.handle, f.variant, f.price)+'</div>'
               : '')
            + '</section>';
    } else {
      html += '<p class="res__note">There is no hill set for this map face yet. It is on the list &mdash; tell us you want it and we’ll weight it higher.</p>';
    }
  }
  resEl.innerHTML = html;
}

function render(){ renderList(); renderResult(); }

/* ---------- mobile drill-down ----------
   Narrow screens show the picker OR the answer, not both stacked, so a
   selection lands on screen instead of a screen and a half further down. */
var bodyEl = root.querySelector(".hf__body");
function setView(v){ bodyEl.setAttribute("data-view", v); }
function jumpToTop(){
  var anchor = root.querySelector(".hf__tabs");
  if(!anchor) return;
  var y = anchor.getBoundingClientRect().top + window.pageYOffset - 8;
  try{ window.scrollTo({top:y, behavior: reduceMotion.matches ? "auto" : "smooth"}); }
  catch(e){ window.scrollTo(0, y); }
}

/* ---------- events ---------- */
/* every product link opens in a new tab, even where a <base target> or an
   embedding frame would otherwise swallow target="_blank" */
resEl.addEventListener("click", function(e){
  /* back to the picker on mobile */
  if(e.target.closest("[data-back]")){ setView("list"); jumpToTop(); return; }
  /* add one */
  var add = e.target.closest("[data-add]");
  if(add){
    if(!ON_SHOPIFY){ window.open(add.getAttribute("data-href"), "_blank", "noopener,noreferrer"); return; }
    cartAdd([add.getAttribute("data-add")], add);
    return;
  }
  /* add the whole list */
  var all = e.target.closest("[data-addall]");
  if(all){
    var list = all.getAttribute("data-addall").split(",");
    if(!ON_SHOPIFY){ return; }
    cartAdd(list, all, "Added " + list.length + " &#10003;");
    return;
  }
  /* every product link opens in a new tab, even where a <base target> or an
     embedding frame would otherwise swallow target="_blank" */
  var a = e.target.closest("a[href]");
  if(!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  e.preventDefault();
  window.open(a.href, "_blank", "noopener,noreferrer");
});

listEl.addEventListener("click", function(e){
  var b = e.target.closest(".opt"); if(!b) return;
  sel[tab] = b.getAttribute("data-id");
  render();
  if(mqNarrow.matches){ setView("detail"); jumpToTop(); }
});
root.querySelector(".hf__search").addEventListener("input", function(e){ q = e.target.value; renderList(); });
root.querySelectorAll(".hf__tabs button").forEach(function(b){
  b.addEventListener("click", function(){
    tab = b.getAttribute("data-tab");
    root.querySelectorAll(".hf__tabs button").forEach(function(x){ x.setAttribute("aria-selected", String(x === b)); });
    q = ""; root.querySelector(".hf__search").value = "";
    setView("list");
    render();
    if(mqNarrow.matches) jumpToTop();
  });
});
var finishNote = document.getElementById("hf-finishnote");
function setFinishNote(){
  var on = root.querySelector('.seg button[aria-pressed="true"]');
  if(on && finishNote) finishNote.textContent = on.getAttribute("data-tip");
}
root.querySelectorAll(".seg button").forEach(function(b){
  b.addEventListener("click", function(){
    color = b.getAttribute("data-color");
    root.querySelectorAll(".seg button").forEach(function(x){ x.setAttribute("aria-pressed", String(x === b)); });
    setFinishNote();
    render();
  });
});
setFinishNote();
setCounts();

render();
refreshCart();

/* the buyer may have changed their cart in another tab */
window.addEventListener("focus", function(){ refreshCart(); });
document.addEventListener("visibilitychange", function(){
  if(!document.hidden) refreshCart();
});
})();